.root {
  min-width: 56px;
  flex-shrink: 0;
}

.alignItemsFlexStart {
  margin-top: 8px;
}
